// Calls from the browser to the public API. Errors carry the server's message.
export async function api(path, options = {}) {
  const res = await fetch(path, {
    credentials: 'same-origin',
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const err = new Error((data && data.error) || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

// An ad click's attribution (?utm_source=…) is recorded without the visitor doing anything.
export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  for (const key of ['utm_source', 'utm_campaign', 'utm_medium']) {
    const value = params.get(key);
    if (value) utm[key] = value;
  }
  return utm;
}
